<template>
<div>
  <v-container  
    class="overflow-y-auto" 
    id="scroll-target" 
    style="max-height: 700px; height:700px" 
    primary>
    <v-app-bar color="primary" dark rounded flat>
      <v-toolbar-title>アクティビティレコード</v-toolbar-title>
    </v-app-bar>
    <div v-if="timeLine.length!==0">
      <v-card
        v-for="(record, i) in sortArrays(timeLine)"
        :key="i"
        outlined
        class="mb-2"
      >
        <div class="d-flex flex-no-wrap justify-space-between">
          <v-card-text>
            <div class="text-left">
              {{ dispRecordAt(record.recordAt) }}
            </div>
            <h4 class="font-weight-bold mt-3">{{ record.recordContent }}</h4>
            <p class="text-center">{{ record.recordImpresstion }}</p>
          </v-card-text>
        </div>
        <v-card-actions>
          <v-list-item class="grow">
            <v-list-item-avatar>
              <v-img
              class=""
              :src="record.recordUser.userPhotoURL"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="text-left">
              <v-list-item-title v-if="record.recordUser.userId === $store.getters.loginUserId">
                <router-link :to="{ name: 'User'}">{{record.recordUser.userName}}</router-link>
              </v-list-item-title>
              <v-list-item-title v-else>
                <router-link :to="{ name: 'User', params: { user_id: record.recordUser.userId }}">
                  {{record.recordUser.userName}}
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <v-row align="center" justify="end">
              <v-btn icon v-show="!isLiked(record)" @click.stop="createLike(record)">
                <v-icon>{{'mdi-fire'}}</v-icon>
              </v-btn>
              <v-btn icon v-show="isLiked(record)" @click.stop="deleteLike(record)" >
                <v-icon color="orange">{{'mdi-fire'}}</v-icon>
              </v-btn>
              <v-btn @click.stop="toggleLikeModal(record.likeList)" 
                small 
                text 
                min-width="25px" 
                class="mr-2 px-0 py-0">
                {{ likeCount(record)}}
              </v-btn>
              <v-btn icon @click.stop="openCommentModal(record)">
                <v-icon>mdi-chat</v-icon>
              </v-btn>
              <v-btn @click.stop="openCommentModal(record)"
                small 
                text 
                min-width="25px" 
                class="px-0 py-0">
                {{ commentCount(record) }}
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
      <record-comment-modal-component :record="record" />
      <v-dialog v-model="likeMemberModal" max-width="300px" persistent>
        <v-card class="overflow-y-auto">
          <v-app-bar color="primary" dense dark>
            <v-card-title>応援しているユーザー</v-card-title>
          </v-app-bar>
          <v-card-text class="mt-3">
            <v-list v-for="(like, i) in likeList" :key="i">
              <v-list-item>
                <v-list-item-avatar><v-img :src="like.likeUserPhotoURL"></v-img></v-list-item-avatar>
                <v-list-item-content>{{ like.likeUserName }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-text class="text-right">
            <v-btn color="secondary" @click.stop='toggleLikeModal'>閉じる</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-card outlined>
        <div class="d-flex flex-no-wrap justify-space-between">
          <v-card-text>
            <h4 class="text-center">まだタイムラインに表示する項目がありません</h4>
            <p class="text-center">あなたやフレンドがジョブを実施した記録や、グループの活動状況が表示されます</p>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </v-container>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import RecordCommentModalComponent from '../components/RecordCommentModal.vue';
import _ from 'lodash';
import moment from 'moment';
export default {
  name: 'TimeLineComponent',
  components: {
    RecordCommentModalComponent
  },
  data(){
    return{
      record: {},
      likeList: [],
      likeMemberModal: false
    }
  },
  computed:{
    timeLine(){
      return this['record/timeLine']
    },
    likeCount() {
      return function (record) {
        return record.likeList.length;
      };
    },
    commentCount() {
      return function (record) {
        return record.commentList.length
      };
    },
    dispRecordAt(){
      return function(recordAt){
        return moment.unix(recordAt.seconds).format('YYYY-MM-DD HH:mm');
      }
    },
    isLiked(){
      return function(record){
        return record.likeList.some(like => like.likeUserId === this.loginUserId)
      }
    },
    ...mapGetters(['loginUserId', 'record/timeLine'])
  },
  methods:{
     sortArrays(timeLine) {
       timeLine = _.orderBy(timeLine, record => record.recordAt, 'desc');
       timeLine = _.uniqBy(timeLine, record => record.recordId)
       return timeLine;
     },
     createLike(record){
       this['record/addLike'](record.recordId);
     },
     deleteLike(record){
       const likeId = record.likeList.find(like => like.likeUserId === this.loginUserId).likeId;
       this['record/removeLike']({recordId: record.recordId, likeId: likeId});
     },
     openCommentModal(record){
       this.toggleCommentModal()
       this.record = record
     },
     toggleLikeModal(likeList){
       likeList ? this.likeList = likeList : this.likeList = [];
       this.likeMemberModal = !this.likeMemberModal;
     },
    ...mapActions(['record/addLike','record/removeLike','toggleCommentModal'])
  }
}
</script>
<style scoped lang="scss">
a {
  text-decoration: none;
  color: black
}
</style>
